import axiosClient from './axiosClient';

export default {
  // calcolo statistiche
  getDashboardStats: (year) =>
    axiosClient.get('/stats/dashboard', {
      params: { year }
    }),
};